import { jotaiStore } from '@shared/store/jotai/jotai-store';

import type { Language } from '@entities/language/model/types';

import { languageAtom } from '@entities/language/store/language.atom';

export const changeLanguage = (language: Language) => {
  jotaiStore.set(languageAtom, (prev) => {
    if (
      prev.locale === language.locale &&
      prev.displayName === language.displayName &&
      prev.direction === language.direction
    ) {
      return prev;
    }

    return { ...prev, ...language };
  });
};
